import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IStatoLavorazione } from "../../../../../../../interfaces/dettaglio/attributes/models";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { isFilterAndValueSelected } from "../../../../../../../lib/filters";
import { useAppSelector } from "../../../../../../../store/hooks";
import { IFilterProps } from "../../interfaces";

const i18_PATH = "prodotto.list.filters.";

function StatoLavorazioneFilter({ filters, setFilters }: IFilterProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  const statoLavorazioneList = useAppSelector(
    (state) => state.dettaglio_stato_lavorazione.list
  );
  const statoLavorazioneItems = useAppSelector(
    (state) => state.dettaglio_stato_lavorazione.items
  );

  const list: IStatoLavorazione[] = useMemo(
    () =>
      !!statoLavorazioneList && !!statoLavorazioneItems
        ? statoLavorazioneList
            .map((id) => statoLavorazioneItems[id])
            .sort((a, b) =>
              a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : -1
            )
        : [],
    [statoLavorazioneList, statoLavorazioneItems]
  );

  const toggle = () => {
    setOpen(!open);
  };

  const toggleSelected = (item: IStatoLavorazione) => {
    if (
      isFilterAndValueSelected(filters, EOptionType.statoLavorazione, item.id)
    ) {
      setFilters(
        filters.filter(
          (opt) =>
            !(
              opt.type === EOptionType.statoLavorazione &&
              opt.numericValue === item.id
            )
        )
      );
    } else {
      setFilters([
        ...filters,
        {
          type: EOptionType.statoLavorazione,
          numericValue: item.id,
          stringValue: item.nome,
        },
      ]);
    }
  };
  return (
    <>
      <ListItemButton onClick={toggle}>
        <ListItemIcon>
          <Icon
            className="fa-light fa-screwdriver-wrench"
            sx={{ overflow: "visible" }}
          />
        </ListItemIcon>
        <ListItemText primary={t(`${i18_PATH}StatoLavorazione`)} />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense={true}>
          {list.map((item) => (
            <ListItemButton
              key={item.id}
              sx={{ display: "flex", pl: 5, pr: 1 }}
              onClick={() => toggleSelected(item)}
              selected={isFilterAndValueSelected(
                filters,
                EOptionType.statoLavorazione,
                item.id
              )}
            >
              <ListItemText sx={{ flex: 1 }} primary={item.nome} />
              <ListItemIcon sx={{ minWidth: 0 }}>
                {isFilterAndValueSelected(
                  filters,
                  EOptionType.statoLavorazione,
                  item.id
                ) && (
                  <Icon
                    className="fa-light fa-check"
                    sx={{ overflow: "visible" }}
                  />
                )}
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default StatoLavorazioneFilter;
